import React, { Suspense, useState, useEffect, useRef, ChangeEvent } from 'react';
import { read, utils } from 'xlsx';
import "../../../App.css"
import { BASE_URL, INPUT_FORMS, EXPORT, SKU_PERF, SKU_PERF_BY_COUNTRY, EXCLUSIONS, STATUSES, BULK_UPDATE, QUARTERS, TYPES, CUTOFFTIME, FILTERS, BEST_PERFORMING } from '../../../constant/apiEndpoints';
import APIService from '../../../services/APIService';
import MultipleSelectCheckmarks from '../../../components/dropDownMultiSelectCustom'
import SingleSelectDropDown from '../../../components/singleSelectDropDown';
import Spinner from 'react-bootstrap/Spinner';
import SKUSpecificSearchBar from '../../../components/skuSpecificSearchBar';
import toast, { Toaster } from 'react-hot-toast';
import SKUDialogueBox from '../../../components/skuDialogueBox';
import SKUBanPopupModal from '../../../components/skuBanPopupModal';
import TableSKUExclusion from '../../../components/tableSKUExclusion'

import TableSKUBestPerforming from '../../../components/tableSKUBestPerforming';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { access } from '../../../utils';
import { useParams } from 'react-router-dom';
import { initialColumns } from './constants';
import { IAPIReturn } from '../../../services/_interfaces';
 
type IProps = {
 
}

type IAPIQarter = {
    label: string; value: string; is_current_quarter: boolean
}

type IQuarter = {
    id: string; title: string; is_current_quarter: boolean
}



const ExclusionList:React.FC<IProps> = (props) => {
        const { id } = useParams<{id: string}>();
        const skuExclusionUpload = useRef<HTMLInputElement>(null);
    
        const [countryList, setCountryList] = React.useState([]);
        const [bestPerformingCountryList, setBestPerformingCountryList] = React.useState([]);
        const [exclusionStatusFilterList, setExclusionStatusFilterList] = React.useState([]);
        const [typeFilterList, setTypeFilterList] = React.useState([]);
        const [itemCategoryList, setItemCategoryList] = useState([]);
        const [quarterList, setQuarterList] = React.useState<{id:string, title:string, is_current_quarter:boolean}[]>([]);
        const [bestPerformingQuarterList, setBestPerformingQuarterList] = React.useState<IQuarter[]>([]);
        const [columns, setColumns] = React.useState(initialColumns);
        const [skuPerformanceList, setSkuPerformanceList] = React.useState<any[]>([]);
        const [skuBestPerformingList, setSkuBestPerformingList] = React.useState<any[]>([]);
        const [skuExclusionStatuses, setSkuExclusionStatuses] = React.useState<{id: String, title:string}[]>([]);
        const [changedSKUExclusionObjects, setChangedSKUExclusionObjects] = React.useState<any[]>([]);
        const [changedSKUBestPerformingObjects, setChangedSKUBestPerformingObjects] = React.useState<any[]>([]);
        const [changedSKUDeleteListObjects, setChangedSKUDeleteListObjects] = React.useState<any[]>([]);
        const [skuExclusionTypes, setSkuExclusionTypes] = React.useState<{title:string, id:string}[]>([]);
        const [selectedCountries, setSelectedCountries] = React.useState<any[]>([]);
        const [selectedBestPerformingCountries, setBestPerformingSelectedCountries] = React.useState<any[]>([]);
        const [selectedExclusionStatuses, setSelectedExclusionStatuses] = React.useState<any[]>([]);
        const [selectedItemCategoryList, setSelectedItemCategoryList] = useState<any[]>([]);
        const [selectedTypes, setSelectedTypes] = React.useState<any[]>([]);
        const [selectedQuarters, setSelectedQuarters] = React.useState<any[]>([]);
        const [selectedbestPerformingQuarters, setSelectedBestPerformingQuarters] = React.useState<any[]>([])
        const [currentQuarter, setCurrentQuarter] = React.useState<string>("")
        const [currentBestPerformingQuarter, setCurrentBestPerformingQuarter] = React.useState<string>("")
        const [dropDownTimer, setDropDownTimer] = useState<any>(0);
        const [search, setSearch] = useState("");
        const [bestPerformingSearch, setBestPerformingSearch] = useState("");
        const [loading, setLoading] = useState(true);
        const [bestPerformingTabLoading, setBestPerformingTabLoading] = useState(true);
        const [openCommentDialogueBox, setOpenCommentDialogueBox] = useState(false);
        const [isBanPopupModalOpen, setIsBanPopupModalOpen] = useState(false);
        const [selectedBan, setSelectedBan] = useState(null);
        const [selectedCountry, setSelectedCountry] = useState("");
        const [isExclusionCutOffTime, setExclusionCutOffTime] = useState(false);
        const [isNarrativeCutOffTime, setNarrativeCutOffTime] = useState(false);
        const [isTypeCommentApplicable, setIsTypeCommentApplicable] = useState(false);
        const [alertMessage, setAlertMessage] = useState("")
        const [selectedTable, setSelectedTable] = useState("sku_exclusion_table")
        const [admin, setAdmin] = React.useState(access.isAdmin(id))
    
        const handleCommentDialogueBox = () => {
            setOpenCommentDialogueBox(!openCommentDialogueBox);
            if (isTypeCommentApplicable) setIsTypeCommentApplicable(false);
        }
    
        const handleBanPopupModal = (id = null, selectedBU = "") => {
            if (id !== null) {
                setSelectedBan(id)
            }
            if (selectedBU !== "") {
                setSelectedCountry(selectedBU)
            }
            setIsBanPopupModalOpen(!isBanPopupModalOpen)
        }
    
        const setDropDownValues = (objs:any[], valueType:string) => {
            if (valueType === "Business Unit") {
                setSelectedCountries(objs)
            }
            if (valueType === "Quarter") {
                setSelectedQuarters(objs)
            }
            if (valueType === "Exclusion Reason") {
                setSelectedExclusionStatuses(objs)
            }
            if (valueType === "Narrative") {
                setSelectedTypes(objs)
            }
            if (valueType === "Item Category") {
                setSelectedItemCategoryList(objs)
            }
            //Loading KBI Values which is dependent on Business Unit Dropdown
            if (valueType === "Business Unit") {
                loadSKUPerformanceList(objs, true, search, columns, selectedQuarters, selectedExclusionStatuses, selectedTypes, selectedItemCategoryList);
                loadQuarters(objs, selectedExclusionStatuses, selectedTypes, selectedItemCategoryList);
                loadExclusionStatusFilter(objs, selectedTypes, selectedQuarters, selectedItemCategoryList);
                loadTypeFilter(objs, selectedExclusionStatuses, selectedQuarters, selectedItemCategoryList);
                loadItemCategoryList(objs,selectedExclusionStatuses, selectedQuarters, selectedTypes)
            }
            //Loading KBI Values which is dependent on Quarter Dropdown
            if (valueType === "Quarter") {
                loadSKUPerformanceList(selectedCountries, true, search, columns, objs, selectedExclusionStatuses, selectedTypes, selectedItemCategoryList);
                loadCountries(selectedExclusionStatuses, selectedTypes, objs, selectedItemCategoryList);
                loadExclusionStatusFilter(selectedCountries, selectedTypes, objs, selectedItemCategoryList);
                loadTypeFilter(selectedCountries, selectedExclusionStatuses, objs, selectedItemCategoryList);
                loadItemCategoryList(selectedCountries,selectedExclusionStatuses, objs, selectedTypes)
            }
            //Loading KBI Values which is dependent on Exclusion Reason Dropdown
            if (valueType === "Exclusion Reason") {
                loadSKUPerformanceList(selectedCountries, true, search, columns, selectedQuarters, objs, selectedTypes, selectedItemCategoryList);
                loadCountries(objs, selectedTypes, selectedQuarters, selectedItemCategoryList);
                loadQuarters(selectedCountries, objs, selectedTypes, selectedItemCategoryList);
                loadTypeFilter(selectedCountries, objs, selectedQuarters, selectedItemCategoryList);
                loadItemCategoryList(selectedCountries,objs, selectedQuarters, selectedTypes)            
            }
            //Loading KBI Values which is dependent on Type Dropdown
            if (valueType === "Narrative") {
                loadSKUPerformanceList(selectedCountries, true, search, columns, selectedQuarters, selectedExclusionStatuses, objs, selectedItemCategoryList);
                loadCountries(selectedExclusionStatuses, objs, selectedQuarters, selectedItemCategoryList);
                loadQuarters(selectedCountries, selectedExclusionStatuses, objs, selectedItemCategoryList);
                loadExclusionStatusFilter(selectedCountries, objs, selectedQuarters, selectedItemCategoryList);
                loadItemCategoryList(selectedCountries,selectedExclusionStatuses, selectedQuarters, objs)
            }
            if (valueType === "Item Category") {
                loadSKUPerformanceList(selectedCountries, true, search, columns, selectedQuarters, selectedExclusionStatuses, selectedTypes, objs);
                loadCountries(selectedExclusionStatuses, selectedTypes, selectedQuarters, objs);
                loadQuarters(selectedCountries, selectedExclusionStatuses, selectedTypes, objs);
                loadExclusionStatusFilter(selectedCountries, selectedTypes, selectedQuarters, objs);
                loadTypeFilter(selectedCountries, selectedTypes, selectedQuarters, objs);
            }
        }
    
        const setBestPerformingDropDownValues = (objs: any[], valueType:string) => {
            if (valueType === "Business Unit") {
                setBestPerformingSelectedCountries(objs)
            }
            if (valueType === "Quarter") {
                setSelectedBestPerformingQuarters(objs)
            }
            //Loading KBI Values which is dependent on Business Unit Dropdown
            if (valueType === "Business Unit") {
                loadSKUBestPerformingList(objs, true, bestPerformingSearch, columns, selectedbestPerformingQuarters);
                loadBestPerformingQuarters(objs);
            }
            //Loading KBI Values which is dependent on Quarter Dropdown
            if (valueType === "Quarter") {
                loadSKUBestPerformingList(selectedBestPerformingCountries, true, bestPerformingSearch, columns, objs);
                loadBestPerformingCountries(objs);
            }
        }
    
        const maintainUserInteractionsWithData = (data: any[]) => {
            const result = data.map(function (x) {
                var result = changedSKUExclusionObjects.filter(a1 => a1.id == x.id);
                if (result.length > 0) { x.exclusion_id = result[0].exclusion_id; }
                return x
            })
    
            return result
        }
        const maintainUserInteractionsWithDataForBestPerforming = (data: any[]) => {
            const result = data.map(function (x) {
                var result = changedSKUBestPerformingObjects.filter(a1 => a1.id == x.id);
                if (result.length > 0) { x.exclusion_id = result[0].exclusion_id; }
                return x
            })
    
            return result
        }
    
        const updateChangedSKUExclusions = (data: any[]) => {
            // setChangedSKUExclusions(data);
            setIsTypeCommentApplicable(validateData(data));
            setChangedSKUExclusionObjects(data);
        }
    
        const updateChangedSKUDelete = (data: any[]) => {
            // setChangedSKUExclusions(data);
            setChangedSKUDeleteListObjects(data);
        }
    
        const updateChangedSKUBestPerforming = (data: any[]) => {
            // setChangedSKUExclusions(data);
            setChangedSKUBestPerformingObjects(data);
        }
    
        //Dropdown Handler As Parent Component
        const setExclusionDropDownValues = (data: any[]) => {
            setSkuPerformanceList(data);
        }
    
            //Dropdown Handler As Parent Component
        const setBestPerformingValues = (data: any[]) => {
            setSkuBestPerformingList(data);
        }
    
        const handleQuarterSelection = (value: any[]) => {
            setSelectedQuarters(value);
            loadSKUPerformanceList(selectedCountries, true, search, columns, value, selectedExclusionStatuses, selectedTypes, selectedItemCategoryList);
        }
    
        const handleQuarterSelectionForBestPerforming = (value: any[]) => {
            setSelectedBestPerformingQuarters(value);
            loadSKUBestPerformingList(selectedCountries, true, bestPerformingSearch, columns, value);
        }
    
        const handleSorting = (newData: any[]) => {
            loadSKUPerformanceList(selectedCountries, true, search, newData);
        }
    
        const handleBestPerformingSorting = (newData: any[]) => {
            loadSKUBestPerformingList(selectedCountries, true, bestPerformingSearch, newData);
        }
    
        //Support Function For Country List
        const createStringFromCountryObjectList = (objs: any[]) => {
            let newString = ""
            for (var i = 0; i < objs.length; i++) {
                if (newString.length === 0) {
                    newString = objs[i].value
                } else {
                    newString = newString + "," + objs[i].value
                }
            }
            return encodeURIComponent(newString)
        }
    
        //AJAX Call To Load Business Units
        const loadCountries = async (exclusionStatuses = selectedExclusionStatuses, types = selectedTypes, quarters = selectedQuarters, categories = selectedItemCategoryList) => {
            //ExclusionStatus filter
            let selectedExclusionStatusFilter = getExclusionStatusFilter(exclusionStatuses)
            //Type filter
            let selectedTypeFilter = getTypeFilter(types)
            //Quarter filter
            let selectedQuarterFilter = getQuarterFilter(quarters)
            //Item Category Filter
            let selectedItemCategoryFilter = getItemCategoryFilter(categories)
    
            let url = BASE_URL + INPUT_FORMS + SKU_PERF_BY_COUNTRY + EXCLUSIONS + FILTERS + `?selected_form=${id}` + `&filter_type=country__name` + selectedExclusionStatusFilter + selectedTypeFilter + selectedQuarterFilter + selectedItemCategoryFilter
            let response: IAPIReturn = await new APIService().get(url);
            if (response.error) {
                console.log("error in user countrylist API", response.results.message)
            } else {
                if (response.results.length > 0) {
                    setCountryList(response.results);
                }
            }
        }
    
        //AJAX Call To Load Best Performing Business Units
        const loadBestPerformingCountries = async (quarters = selectedbestPerformingQuarters) => {
            
            //Quarter filter
            let selectedQuarterFilter = getQuarterFilter(quarters)
    
            let url = BASE_URL + INPUT_FORMS + SKU_PERF_BY_COUNTRY + EXCLUSIONS + BEST_PERFORMING + FILTERS + `?selected_form=${id}` + `&filter_type=country__name` + selectedQuarterFilter
            let response: IAPIReturn = await new APIService().get(url);
            if (response.error) {
                console.log("error in user countrylist API", response.results.message)
            } else {
                if (response.results.length > 0) {
                    setBestPerformingCountryList(response.results);
                }
            }
        }
    
        //AJAX Call To Load Exclusion Reason Filter Dta
        const loadExclusionStatusFilter = async (countries = selectedCountries, types = selectedTypes, quarters = selectedQuarters, categories = selectedItemCategoryList) => {
            //Country filter
            let selectedCountryFilter = getCountryFilter(countries)
            //Type filter
            let selectedTypeFilter = getTypeFilter(types)
            //Quarter filter
            let selectedQuarterFilter = getQuarterFilter(quarters)
            //Item Category Filter
            let selectedItemCategoryFilter = getItemCategoryFilter(categories)
    
            let url = BASE_URL + INPUT_FORMS + SKU_PERF_BY_COUNTRY + EXCLUSIONS + FILTERS + `?selected_form=${id}` + `&filter_type=exclusion_id` + selectedCountryFilter + selectedTypeFilter + selectedQuarterFilter + selectedItemCategoryFilter
            let response: IAPIReturn = await new APIService().get(url);
            if (response.error) {
                console.log("error in user countrylist API", response.results.message)
            } else {
                if (response.results.length > 0) {
                    setExclusionStatusFilterList(response.results);
                }
            }
        }
    
        //AJAX Call To Load Type Filter Dta
        const loadTypeFilter = async (countries = selectedCountries, exclusionStatuses = selectedExclusionStatuses, quarters = selectedQuarters, categories = selectedItemCategoryList) => {
            //Country filter
            let selectedCountryFilter = getCountryFilter(countries)
            //ExclusionStatus filter
            let selectedExclusionStatusFilter = getExclusionStatusFilter(exclusionStatuses)
            //Quarter filter
            let selectedQuarterFilter = getQuarterFilter(quarters)
            //Item Category Filter
            let selectedItemCategoryFilter = getItemCategoryFilter(categories)
    
            let url = BASE_URL + INPUT_FORMS + SKU_PERF_BY_COUNTRY + EXCLUSIONS + FILTERS + `?selected_form=${id}` + `&filter_type=type__title` + selectedCountryFilter + selectedExclusionStatusFilter + selectedQuarterFilter + selectedItemCategoryFilter
            let response: IAPIReturn = await new APIService().get(url);
            if (response.error) {
                console.log("error in user countrylist API", response.results.message)
            } else {
                    setTypeFilterList(response.results);
                
            }
        }
    
        const loadItemCategoryList = async (countries = selectedCountries, exclusionStatuses = selectedExclusionStatuses, quarters = selectedQuarters, types = selectedTypes) => {
            //Country filter
            let selectedCountryFilter = getCountryFilter(countries)
            //ExclusionStatus filter
            let selectedExclusionStatusFilter = getExclusionStatusFilter(exclusionStatuses)
            //Quarter filter
            let selectedQuarterFilter = getQuarterFilter(quarters)
            //Type filter
            let selectedTypeFilter = getTypeFilter(types)
    
            let url = BASE_URL + INPUT_FORMS + SKU_PERF_BY_COUNTRY + EXCLUSIONS + FILTERS + `?selected_form=${id}` + `&filter_type=category` + selectedQuarterFilter + selectedCountryFilter + selectedTypeFilter + selectedExclusionStatusFilter
            let response: IAPIReturn = await new APIService().get(url);
            if (response.error) {
                console.log("error in Category List API", response.results.message)
            } else {
                    setItemCategoryList(response.results);
            }
        }
    
        //AJAX Call To Load Quarters
        const loadQuarters = async (countries = selectedCountries, exclusionStatuses = selectedExclusionStatuses, types = selectedTypes, categories = selectedItemCategoryList) => {
            //Country filter
            let selectedCountryFilter = getCountryFilter(countries)
            //ExclusionStatus filter
            let selectedExclusionStatusFilter = getExclusionStatusFilter(exclusionStatuses)
            //Type filter
            let selectedTypeFilter = getTypeFilter(types)
            //Item Category Filter
            let selectedItemCategoryFilter = getItemCategoryFilter(categories)
    
            let url = BASE_URL + INPUT_FORMS + SKU_PERF_BY_COUNTRY + EXCLUSIONS + QUARTERS + `?selected_form=${id}` + selectedCountryFilter + selectedExclusionStatusFilter + selectedTypeFilter + selectedItemCategoryFilter
            let response: IAPIReturn = await new APIService().get(url);
            if (response.error) {
                console.log("error in user quarterlist API", response.results.message)
            } else {
                if (response.results.length > 0) {
                    const transformedData:IQuarter[] = response.results.map(({label, value, is_current_quarter}:IAPIQarter) => ({ id: value, title: label, is_current_quarter: is_current_quarter }));
                    setQuarterList(transformedData);
                    debugger;
                    //Setting Current Quarter
                    var object = transformedData.find(obj => {
                        return obj.is_current_quarter === true
                    })
                    if (object) {
                        setCurrentQuarter(object.id)
                    }
                }
            }
        }
    
        //AJAX Call To Load Quarters
        const loadBestPerformingQuarters = async (countries = selectedCountries) => {
            //Country filter
            let selectedCountryFilter = getCountryFilter(countries)
            
            let url = BASE_URL + INPUT_FORMS + SKU_PERF_BY_COUNTRY + EXCLUSIONS + QUARTERS + `?selected_form=${id}` + selectedCountryFilter
            debugger;
            let response : IAPIReturn = await new APIService().get(url);
            if (response.error) {
                console.log("error in user quarterlist API", response.results.message)
            } else {
                if (response.results.length > 0) {
                    const transformedData:IQuarter[] = response.results.map(({ label, value, is_current_quarter }:IAPIQarter) => ({ id: value, title: label, is_current_quarter: is_current_quarter }));
                    setBestPerformingQuarterList(transformedData);
                    //Setting Current Quarter
                    var object = transformedData.find(obj => {
                        return obj.is_current_quarter === true
                    })
                    if (object) setCurrentBestPerformingQuarter(object.id)
                }
            }
        }
    
        const loadSKUExclusionStatuses = async () => {
            let url = BASE_URL + INPUT_FORMS + SKU_PERF + EXCLUSIONS + STATUSES + `?selected_form=formsku`
            let response: IAPIReturn = await new APIService().get(url);
            if (response.error) {
                console.log("error in user countrylist API", response.results.message)
            } else {
                if (response.results.length > 0) {
                    // const transformedData = response.results.map(({ id, title }) => ({ label: title, value: id }));
                    setSkuExclusionStatuses(response.results);
                }
            }
        }
    
        const loadSKUExclusionTypes = async () => {
            let url = BASE_URL + INPUT_FORMS + SKU_PERF + EXCLUSIONS + TYPES + `?selected_form=formsku`
            let response: IAPIReturn = await new APIService().get(url);
            if (response.error) {
                console.log("error in user countrylist API", response.results.message)
            } else {
                if (response.results.length > 0) {
                    // const transformedData = response.results.map(({ id, title }) => ({ label: title, value: id }));
                    setSkuExclusionTypes(response.results);
                }
            }
        }
    
        const loadCutOffTime = async () => {
            let url = BASE_URL + INPUT_FORMS + SKU_PERF + EXCLUSIONS + CUTOFFTIME + `?selected_form=formsku`
            let response: IAPIReturn = await new APIService().get(url);
            if (response.error) {
                console.log("error in Channel List API", response.results.message)
            } else {
                if (response.results) {
                    setExclusionCutOffTime(response.results.exclusion_cut_off_time_active);
                    setNarrativeCutOffTime(response.results.narrative_cut_off_time_active)
                }
            }
        }
    
        const getCountryFilter = (countryIDs: any[] | null) => {
            //Getting User Selected Business Units By State/User Action
            let selectedCountryList = countryIDs !== null ? countryIDs : selectedCountries
            let selectedCountryFilter = ""
            if (selectedCountryList.length !== 0) {
                selectedCountryFilter = `&selected_country=${createStringFromCountryObjectList(selectedCountryList)}`
            }
            return selectedCountryFilter
        }
    
        const getExclusionStatusFilter = (exclusionStatusIDs: any[] | null) => {
            //Getting User Selected Exclusion Reason By State/User Action
            let selectedExclusionStatusList = exclusionStatusIDs !== null ? exclusionStatusIDs : selectedExclusionStatuses
            let selectedExclusionStatusFilter = ""
            if (selectedExclusionStatusList.length !== 0) {
                selectedExclusionStatusFilter = `&selected_exclusion=${createStringFromCountryObjectList(selectedExclusionStatusList)}`
            }
            return selectedExclusionStatusFilter
        }
    
        const getTypeFilter = (typeIDs: any[] | null) => {
            //Getting User Selected Type By State/User Action
            let selectedTypeList = typeIDs !== null ? typeIDs : selectedTypes
            let selectedTypeFilter = ""
            if (selectedTypeList.length !== 0) {
                selectedTypeFilter = `&selected_type=${createStringFromCountryObjectList(selectedTypeList)}`
            }
            return selectedTypeFilter
        }
    
        const getItemCategoryFilter = (itemCategoryIDs: any[] | null) => {
            //Getting User Selected Data By State/User Action
            let selectedItemCategory = itemCategoryIDs !== null ? itemCategoryIDs : selectedItemCategoryList
            let selectedItemCategoryFilter = ""
            if (selectedItemCategory.length !== 0) {
                selectedItemCategoryFilter = `&selected_item_category=${createStringFromCountryObjectList(selectedItemCategory)}`
            }
            return selectedItemCategoryFilter
        }
    
        const getQuarterFilter = (quarterIDs: any[] | null) => {
            //Getting User Selected Business Units By State/User Action
            let selectedQuarterList = quarterIDs !== null ? quarterIDs : selectedQuarters
            let selectedQuarterFilter = ""
            if (selectedQuarterList.length !== 0) {
                selectedQuarterFilter = `&selected_quarter=${createStringFromCountryObjectList([{ "value": selectedQuarterList }])}`
            }
            return selectedQuarterFilter
        }
    
        const getSearchFilter = (seachFilterArg: string) => {
            let searchFilter = ""
            if (seachFilterArg.length !== 0) {
                searchFilter = `&search=${encodeURIComponent(seachFilterArg)}`
            }
            return searchFilter
        }
    
        const getSortFilter = (sorting:any[]) => {
            let sortFilter = ""
            let asc = ""
            let desc = ""
            for (var i = 0; i < sorting.length; i++) {
                if (sorting[i].is_sortable && sorting[i].is_sorted) {
                    if (sorting[i].sort_type === "asc") {
                        sortFilter = sortFilter + sorting[i].sort_name + ","
                    } else {
                        sortFilter = sortFilter + '-' + sorting[i].sort_name + ","
                    }
                }
            }
            // if(asc.length > 0) sortFilter = `&asc=${asc}`
            // if(desc.length > 0) sortFilter = sortFilter + `&desc=${desc}`
            return `&order=${sortFilter}`
        }
    
        //AJAX Call To Load SKU Performance List
        const loadSKUPerformanceAPICall = async (selectedCountryFilter:string = "", searchFilter:string="", sortFilter:string="", selectedQuarterFilter:string="", selectedExclusionStatusFilter:string="", selectedTypeFilter:string="", selectedItemCategoryFilter:string="") => {
            selectedQuarterFilter = selectedQuarterFilter !== undefined ? selectedQuarterFilter : ""
            selectedExclusionStatusFilter = selectedExclusionStatusFilter !== undefined ? selectedExclusionStatusFilter : ""
            selectedTypeFilter = selectedTypeFilter !== undefined ? selectedTypeFilter : ""
            selectedItemCategoryFilter = selectedItemCategoryFilter !== undefined ? selectedItemCategoryFilter : ""
            setLoading(true)
            let url = BASE_URL + INPUT_FORMS + SKU_PERF_BY_COUNTRY + EXCLUSIONS + `?selected_form=${id}` + selectedCountryFilter + searchFilter + sortFilter + selectedQuarterFilter + selectedExclusionStatusFilter + selectedTypeFilter + selectedItemCategoryFilter
            let response: IAPIReturn = await new APIService().get(url);
            if (response.error) {
                console.log("error in ski exlusion list API", response.results.message)
            } else {
                // if (response.results.length > 0) {
                // const transformedData = response.results.map(({ id, title }) => ({ label: title, value: id }));
                var data = maintainUserInteractionsWithData(response.results);
                setSkuPerformanceList(data);
                // setSkuPerformanceListReference(response.results);
                // }
            }
            setLoading(false);
        }
    
        //AJAX Call To Load SKU Performance List
        const loadSKUBestPerformingAPICall = async (selectedCountryFilter:string = "", searchFilter:string="", sortFilter:string="", selectedQuarterFilter:string="") => {
            selectedQuarterFilter = selectedQuarterFilter !== undefined ? selectedQuarterFilter : ""
            setBestPerformingTabLoading(true)
            let url = BASE_URL + INPUT_FORMS + SKU_PERF_BY_COUNTRY + EXCLUSIONS + BEST_PERFORMING + `?selected_form=${id}` + selectedCountryFilter + searchFilter + sortFilter + selectedQuarterFilter
            let response: IAPIReturn = await new APIService().get(url);
            if (response.error) {
                console.log("error in ski exlusion list API", response.results.message)
            } else {
                // if (response.results.length > 0) {
                // const transformedData = response.results.map(({ id, title }) => ({ label: title, value: id }));
                var data = maintainUserInteractionsWithDataForBestPerforming(response.results);
                setSkuBestPerformingList(data);
                // setSkuPerformanceListReference(response.results);
                // }
            }
            setBestPerformingTabLoading(false);
        }
    
        const loadSKUPerformanceList = async (countryIDs: any[]| null = null, useTimer:boolean, seachFilterArg = "", sorting: any[] = [], quarterIDs: any[] = [], exclusionIDs: any[] = [], typeIDs: any[] = [], categories: any[] = []) => {
            //Country filter
            let selectedCountryFilter = getCountryFilter(countryIDs)
            //ExclusionStatus filter
            let selectedExclusionStatusFilter = getExclusionStatusFilter(exclusionIDs)
            //Type filter
            let selectedTypeFilter = getTypeFilter(typeIDs)
            //Item Category Filter
            let selectedItemCategoryFilter = getItemCategoryFilter(categories)
            //Quarter filter
            let selectedQuarterFilter = getQuarterFilter(quarterIDs)
            //Search filter
            let searchFilter = getSearchFilter(seachFilterArg);
            //Sorting
            let sortFilter = getSortFilter(sorting)
            //Clearing Timeout Before Adding New Timeout(Previous Timeout)
    
            if (dropDownTimer) {
                clearTimeout(dropDownTimer);
            }
            //Add Timeout Before Hitting API
            if (useTimer) {
                setDropDownTimer(
                    setTimeout(function () {
                        // loadBrandCategoryMappingAPICall(selectedBrandFilter, selectedSummarizedBrandFilter, selectedCategorySAPFilter);
                        toast.promise(loadSKUPerformanceAPICall(selectedCountryFilter, searchFilter, sortFilter, selectedQuarterFilter, selectedExclusionStatusFilter, selectedTypeFilter, selectedItemCategoryFilter), {
                            loading: "Loading. wait a moment!",
                            success: 'Data load success.',
                            error: 'Something went wrong.',
                        },
                            {
                                position: 'top-center',
                                className: 'toast-popup',
                            });
                    }, 1000)
                )
            } else {
                loadSKUPerformanceAPICall(selectedCountryFilter, searchFilter, sortFilter);
            }
        }
    
        const loadSKUBestPerformingList = async (countryIDs: any[]| null = null, useTimer:boolean, seachFilterArg = "", sorting: any[] = [], quarterIDs: any[] = []) => {
            //Country filter
            let selectedCountryFilter = getCountryFilter(countryIDs)
            //Quarter filter
            let selectedQuarterFilter = getQuarterFilter(quarterIDs)
            //Search filter
            let searchFilter = getSearchFilter(seachFilterArg);
            //Sorting
            let sortFilter = getSortFilter(sorting)
            //Clearing Timeout Before Adding New Timeout(Previous Timeout)
    
            if (dropDownTimer) {
                clearTimeout(dropDownTimer);
            }
            //Add Timeout Before Hitting API
            if (useTimer) {
                setDropDownTimer(
                    setTimeout(function () {
                        // loadBrandCategoryMappingAPICall(selectedBrandFilter, selectedSummarizedBrandFilter, selectedCategorySAPFilter);
                        toast.promise(loadSKUBestPerformingAPICall(selectedCountryFilter, searchFilter, sortFilter, selectedQuarterFilter), {
                            loading: "Loading. wait a moment!",
                            success: 'Data load success.',
                            error: 'Something went wrong.',
                        },
                            {
                                position: 'top-center',
                                className: 'toast-popup',
                            });
                    }, 1000)
                )
            } else {
                loadSKUBestPerformingAPICall(selectedCountryFilter, searchFilter, sortFilter);
            }
        }
    
        const handleSearchSubmit = (search:string) => {
            setSearch(search);
            loadSKUPerformanceList(selectedCountries, true, search, columns);
        }
    
        const handleBestPerformingSearchSubmit = (srch:string) => {
            setBestPerformingSearch(srch);
            loadSKUBestPerformingList(selectedBestPerformingCountries, true, srch, columns);
        }
    
        const handleApplyAfterAPICall = () => {
            loadSKUPerformanceList(selectedCountries, true, search, columns, selectedQuarters, selectedItemCategoryList);
            setChangedSKUExclusionObjects([]);
        }
    
        const handleBestPerformingApplyAfterAPICall = () => {
            loadSKUBestPerformingList(selectedBestPerformingCountries, true, bestPerformingSearch, columns, selectedbestPerformingQuarters);
            setChangedSKUBestPerformingObjects([]);
        }
    
        const getAPIPayload = (data: any[] = []) => {
            let statusData = []
            let typeData = []
            let data_objects = []
            debugger;
            for (var i = 0; i < data.length; i++) {
                let obj:{
                    exclusion_id: string,
                    exclusion_status_id?: string,
                    exclusion_type_id?: string,
                    comment?: string
                } = {exclusion_id: data[i].id}
                if (data[i].exclusion_id) obj['exclusion_status_id'] = data[i].exclusion_id
                if (data[i].type_id && data[i].exclusion_id === 'A') obj['exclusion_type_id'] = data[i].type_id
                if (data[i].comment && data[i].exclusion_id === 'A') obj['comment'] = data[i].comment
                data_objects.push(obj)
            }
            return { "data_objects": data_objects };
        }
    
        const getBestPerformingAPIPayload = (data: any[]=[]) => {
            let data_objects = []
    
            for (var i = 0; i < data.length; i++) {
                let obj = {exclusion_id: data[i].id}
                data_objects.push(obj)
            }
            return { "data_objects": data_objects };
        }
    
        const handleSubmitAPICall = async () =>{
            if (changedSKUExclusionObjects.length > 0){
                await handleSKUSubmitAPICall()
                handleCommentDialogueBox();
            }
            if (changedSKUDeleteListObjects.length > 0){
                await handleBestPerformingSubmitAPICall("true")
                handleCommentDialogueBox();
            }
        }
    
        const handleSKUSubmitAPICall = async (comment:string | null=null, data:any[] = [], handleModal = true) => {
            toast.loading('Loading...', { position: 'top-center', className: 'toast-popup', duration: 1000 });
            let url = BASE_URL + INPUT_FORMS + SKU_PERF_BY_COUNTRY + EXCLUSIONS + BULK_UPDATE
            let body: any = getAPIPayload(data || changedSKUExclusionObjects)
            if (comment) body["comment"] = comment
            let response: IAPIReturn = await new APIService().patch(url, body)
            if (response.error) {
                if (response.status == 400) {
                    if (response.results.message.includes("This field may not be blank.")) {
                        toast.error('Comment is required!', { position: 'top-center', className: 'toast-popup', duration: 2000 });
                    } else if (response.results.message) {
                        toast.error(response.results.message, { position: 'top-center', className: 'toast-popup', duration: 2000 });
                    } else {
                        toast.error('Something went wrong.', { position: 'top-center', className: 'toast-popup', duration: 2000 });
                    }
                }
            } else {
                toast.success('Data updated successfully.', { position: 'top-center', className: 'toast-popup', duration: 1000 });
                handleApplyAfterAPICall();
                if (handleModal) {
                    handleCommentDialogueBox();
                }
            }
        }
    
        const handleBestPerformingSubmitAPICall = async (del="false") => {
            toast.loading('Loading...', { position: 'top-center', className: 'toast-popup', duration: 1000 });
            let url = BASE_URL + INPUT_FORMS + SKU_PERF_BY_COUNTRY + EXCLUSIONS + BEST_PERFORMING + BULK_UPDATE + "?delete=" + del
            let body = getBestPerformingAPIPayload(del === "false" ? changedSKUBestPerformingObjects : changedSKUDeleteListObjects)
            let response = await new APIService().patch(url, body)
            if (response.error) {
                if (response.status === 400) {
                    toast.error('Something went wrong.', { position: 'top-center', className: 'toast-popup', duration: 2000 });
                }
            } else {
                toast.success('Data updated successfully.', { position: 'top-center', className: 'toast-popup', duration: 1000 });
                if (del === "false"){
                handleBestPerformingApplyAfterAPICall();
                }
                else{
                    loadSKUPerformanceList(selectedCountries, true, search, columns, selectedQuarters, selectedItemCategoryList);
                    setChangedSKUDeleteListObjects([]);
                    handleCommentDialogueBox();
                }
            }
        }
    
        const validateData = (data: any[] = []) => {
            let is_type_available = false;
            let is_comment_available = false;
            if (data.length > 0) {
                data.forEach((element) => {
                    if (element.exclusion_id === "A") {
                        if (!element.type_id) {
                            is_type_available = true
                            setAlertMessage("Current updates will be saved. Please note that you need to update narrative and reason code for every BAN with exclusion reason \"A\"")
                        } else if (element.comment === "" || element.comment === null) {
                            is_comment_available = true
                            setAlertMessage("Current updates will be saved. Please note that you need to update narrative and reason code for every BAN with exclusion reason \"A\"")
                        }
                    } 
                });
            }
            
            return is_type_available || is_comment_available
        }
    
        const handleSave = () => {
            setIsTypeCommentApplicable(validateData(changedSKUExclusionObjects));
            setOpenCommentDialogueBox(!openCommentDialogueBox)
        }
    
        const handleFileUpload = async (e:ChangeEvent<HTMLInputElement>) => {
            debugger;
            if (!e.currentTarget.files?.length) return;
            const file = e.currentTarget.files[0];
            const sheetName = "SKU Exclusions";
            
            if (file) {
                const ab = await file.arrayBuffer();
                const wb = read(ab);
                const exclusions = wb.Sheets[sheetName];
                const exclusionsData:any[] = utils.sheet_to_json(exclusions);
    
                const today = new Date();
                const currentMonth = today.getMonth();
                let quarter = Math.floor((currentMonth + 2) / 3);
                let year = today.getFullYear();
    
                if (currentMonth === 0) {
                    quarter = Math.floor((11 + 3) / 3);
                    year -= 1;
                }
    
                const quarterString = `${year} Q${quarter}`;
                // TODO: FILTER OMITS ALL DATA
                debugger;
                const currentQItems:any[] = exclusionsData.filter((item:any) =>
                    item.Quarter === quarterString);
    
                const newObjects = currentQItems.map((item) => {
                    const type_id =
                        skuExclusionTypes.find((type) => type.title === item["Narrative"])?.id
                        || null
    
                    return {
                        id: (item.Quarter + item['Business Unit'] + item['BAN Number']).replace(/\s/g, ""),
                        exclusion_id: item['Exclusion Reason'],
                        type_id,
                        comment: item.Comment,
                    }
                });
    
                if (newObjects) handleSKUSubmitAPICall(null, newObjects, false);
            }
        }
    
        const exportDataHandle = async () => {
            //Business Unit filter
            let selectedCountryFilter = getCountryFilter(null)
            //Quarter filter
            let selectedQuarterFilter = getQuarterFilter(null)
            //Exclusion filter
            let selectedExclusionStatusFilter = getExclusionStatusFilter(null)
            //Type filter
            let selectedTypeFilter = getTypeFilter(null)
            // Category Filter
            let selectedItemCategoryFilter = getItemCategoryFilter(null)
    
            let url = BASE_URL + INPUT_FORMS + SKU_PERF_BY_COUNTRY + EXCLUSIONS + EXPORT + `?selected_form=${id}` + selectedCountryFilter + selectedQuarterFilter + selectedExclusionStatusFilter + selectedTypeFilter + selectedItemCategoryFilter
            const token = JSON.parse(localStorage.getItem('access_token') || '').access ;
            fetch(url, {
                method: "GET",
                headers: new Headers({
                    "Content-Type": "application/x-www-form-urlencoded",
                    Authorization: `Bearer ${token}`,
                })
            }).then(response =>
                response.blob().then(blob => {
                    var today = new Date()
                    let date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()
                    let time = today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();
                    let url = window.URL.createObjectURL(blob);
                    let a = document.createElement("a");
                    a.href = url;
                    a.download = "exclusion_data_" + date + "_" + time + ".xls";
                    a.click();
                })
            );
        }
    
        //useEffect Method
        useEffect(() => {
            let mounted = true
            if (mounted) {
                loadSKUExclusionStatuses();
                loadSKUExclusionTypes();
                loadCutOffTime();
                loadQuarters();
            }
            return function cleanup() {
                mounted = false
            }
        }, [])
    
        useEffect(() => {
            let mounted = true
            if (mounted) {
                loadBestPerformingCountries();
                loadBestPerformingQuarters();
                // loadCutOffTime();
                
            }
            return function cleanup() {
                mounted = false
            }
        }, [])
    
        useEffect(()=>{
            let mounted = true
            if (mounted) {
            if (selectedTable === "sku_exclusion_table"){
                loadSKUPerformanceList(null, false, search, columns, selectedQuarters, selectedItemCategoryList);
                loadCountries();
                loadExclusionStatusFilter();
                loadTypeFilter();
                loadQuarters();
                loadItemCategoryList();
            }
            else{
                loadSKUBestPerformingList(null, false, bestPerformingSearch, columns, selectedbestPerformingQuarters);
            }
        }
        return function cleanup() {
            mounted = false
        }
        },[selectedTable])
    
        const enableMassImport = !loading && (!isNarrativeCutOffTime || admin);




    return (
         <Suspense fallback={<div>An error occured!</div>}>
                  <div className="user-view-container">
                    {admin && 
                        <div className="row p-0 mb-4 ms-4">
                            <div className="d-flex flex-row-reverse">
                                    <ToggleButtonGroup
                                    value={selectedTable}
                                    size="small"
                                    color="warning"
                                    onChange={(e, value)=>{
                                        setSearch("")
                                        setBestPerformingSearch("")
                                        setSelectedCountries([])
                                        setBestPerformingSelectedCountries([])
                                        setSelectedExclusionStatuses([])
                                        setSelectedTypes([])
                                        setSelectedItemCategoryList([])
                                        setSelectedTable((e.target as any).value)}}
                                    aria-label="text alignment"
                                    >
                                    <ToggleButton className="" size="small" value="sku_exclusion_table" >
                                        sku exclusion table
                                    </ToggleButton>
                                    <ToggleButton className="" size="small" value="best_performing_table" >
                                        Best Performing Bans
                                    </ToggleButton>
                                    </ToggleButtonGroup>
                                </div>
                            </div>
                    }
                        <div className="user-view-header row p-0 mb-4 ms-4">
                        {selectedTable === "sku_exclusion_table" ?
                            <div className="col-8 p-0 m-0 row">
                                <div className="col-2 p-0 m-0">
                                    <MultipleSelectCheckmarks key={"sku-country"} title="Country" options={countryList} setParentDropdownValue={setDropDownValues} />
                                </div>
                                    <div className="col-2 p-0 m-0">
                                        <MultipleSelectCheckmarks title="Exclusion Reason" options={exclusionStatusFilterList} setParentDropdownValue={setDropDownValues} />
                                    </div>
                                    <div className="col-2 p-0 m-0">
                                        <MultipleSelectCheckmarks title="Narrative" options={typeFilterList} setParentDropdownValue={setDropDownValues} />
                                    </div>
                                    <div className="col-2 p-0 m-0">
                                    <MultipleSelectCheckmarks title="Item Category" options={itemCategoryList} setParentDropdownValue={setDropDownValues} />
                                </div>
                                <div className="col-3 p-0 seach-box-container">
                                    <SKUSpecificSearchBar key={"sku-search"} handleSearchSubmit={handleSearchSubmit} />
                                </div>
                            </div>
                            :
                            <div className="col-8 p-0 m-0 row">
                                <div className="col-3 p-0 m-0">
                                    <MultipleSelectCheckmarks key={"best-performing-country"} title="Country" options={bestPerformingCountryList} setParentDropdownValue={setBestPerformingDropDownValues} />
                                </div>
                                <div className="col-3 p-0 seach-box-container">
                                    <SKUSpecificSearchBar key={"best-performing-search"} handleSearchSubmit={handleBestPerformingSearchSubmit} />
                                </div>
                            </div>
                        }
                            {/* <div className="col-3 p-0 mt-4 row">
                                <div className="sku-export-button-container col-6">
                                        <input className="sku-export-button mt-2 col" type="button" value="Export" onClick={exportDataHandle} />
                                    </div>
                            </div> */}
                            <div className="col-4 p-0 mt-4 row">
                                <div className="sku-export-button-container col-8">
                                    {selectedTable === "sku_exclusion_table" &&
                                        <>
                                            <span>
                                                <input
                                                    className="sku-export-button mt-2"
                                                    type="button"
                                                    value="Import"
                                                    disabled={!enableMassImport}
                                                    onClick={() => {
                                                        skuExclusionUpload.current?.click();
                                                    }}
                                                />
            
                                                <input
                                                    ref={skuExclusionUpload}
                                                    id="for-sku"
                                                    style={{display: 'none'}}
                                                    type="file"
                                                    accept=".xls"
                                                    onClick={(e) => {
                                                        const { target = {} }:any = e || {};
                                                        target.value = "";
                                                    }}
                                                    onChange={handleFileUpload}
                                                />
                                            </span>
                                            <span>
                                                <input className="sku-export-button mt-2" type="button" value="Export"
                                                    onClick={exportDataHandle} />
                                            </span>
                                        </>
                                    }
                                    <span>
                                        {selectedTable === "sku_exclusion_table" ?
                                            <input className="exclusion-apply-all-button mt-2" type="button" value="Save"
                                                style={{ backgroundColor: (changedSKUExclusionObjects.length > 0 || changedSKUDeleteListObjects.length > 0) ? "#E61C2A" : "#9B9595" }}
                                                disabled={!(changedSKUExclusionObjects.length > 0 || changedSKUDeleteListObjects.length > 0)}
                                                onClick={handleSave} />
                                                :
                                                <input className="sku-delist-save-button mt-2" type="button" value="Save Changes"
                                                style={{ backgroundColor: changedSKUBestPerformingObjects.length > 0 ? "#E61C2A" : "#9B9595" }}
                                                disabled={changedSKUBestPerformingObjects.length < 1}
                                                onClick={()=>{handleBestPerformingSubmitAPICall("false")}} />
                                        }
                                    </span>
                                </div>
                                {/* <div className="sku-quarter-text text-center mt-2 col-3"> */}
                                {/* {skuPerformanceList.length > 0 ? `${skuPerformanceList[0].year} - ${skuPerformanceList[0].time_frame}` : ""} */}
                                {/* <MultipleSelectCheckmarks title="Quarter" options={quarterList} setParentDropdownValue={setDropDownValues} hideTitle={true} showLabelInDropdown={true} /> */}
                                {/* </div> */}
                                {(currentQuarter !== "" || currentBestPerformingQuarter !== "")? <div className="sku-quarter-selection-dropdown-container text-center p-0 mt-2 col-4">
                                    <SingleSelectDropDown key={selectedTable} options={selectedTable === "sku_exclusion_table" ? quarterList : bestPerformingQuarterList }
                                        preSelectedValue={selectedTable === "sku_exclusion_table" ? currentQuarter : currentBestPerformingQuarter}
                                        setParentDropdownValue={selectedTable ==="sku_exclusion_table" ? handleQuarterSelection: handleQuarterSelectionForBestPerforming} />
                                </div> : ""}
                            </div>
                            
                        </div>
                        {/* Loader(While Data Loading) */}
                        {selectedTable === "sku_exclusion_table" && loading ? <div className="table-data-note"><Spinner animation="border" />
                            <p></p>
                        </div> : ""}
            
                        {selectedTable !== "sku_exclusion_table" && bestPerformingTabLoading ? <div className="table-data-note"><Spinner animation="border" />
                            <p></p>
                        </div> : ""}
            
                        {/* Loader(While Data Loading) */}
                        {/* Cut Off Time Note Banner */}
                        {
                            selectedTable === "sku_exclusion_table" && !admin &&
                            <>
                            {
                                isExclusionCutOffTime && isNarrativeCutOffTime && loading !== true ? 
                                <div className="sku-exclusion-cut-off-note-container">
                                    NOTE: Cut off time is going on. You will NOT be able to Save any changes.
                                </div> 
                                : 
                                isExclusionCutOffTime && loading !== true ? 
                                <div className="sku-exclusion-cut-off-note-container">
                                    NOTE: Cut off time is active on <u>Exclusion Reason</u>. You will NOT be able to make changes to Exclusion Reason Column.
                                </div> 
                                : ""
                            }
                            </>
                        }
                        {/* Cut Off Time Note Banner */}
                        {/* Table(If Data Present) */}
                        {selectedTable === "sku_exclusion_table" ?
                        <>
                        {(skuPerformanceList.length > 0 && !loading) ? (
                            <div className="sku-table-container">
                                <TableSKUExclusion
                                    columns={columns}
                                    handleBanPopupModal={handleBanPopupModal}
                                    handleSorting={handleSorting}
                                    updateChangedSKUExclusions={updateChangedSKUExclusions}
                                    setExclusionDropDownValues={setExclusionDropDownValues}
                                    skuPerformanceList={skuPerformanceList}
                                    skuExclusionStatuses={skuExclusionStatuses} 
                                    skuExclusionTypes={skuExclusionTypes}
                                    changedSKUExclusionObjects={changedSKUExclusionObjects}
                                    changedSKUDeleteListObjects={changedSKUDeleteListObjects}
                                    updateChangedSKUDelete={updateChangedSKUDelete} 
                                    isExclusionCutOffTime={isExclusionCutOffTime}
                                    isNarrativeCutOffTime={isNarrativeCutOffTime}
                                    admin={admin}
                                />
                                                
                                <footer className="sku-legend-container page-footer font-small blue">
                                    <div className="footer-copyright text-center pt-3 row">
                                        {/* <div className="font-small col-2">A = Common articles bottom 1% NC and bottom 5% Volume</div>
                                        <div className="font-small col-2">B = New launches - less than 12 months on the market</div>
                                        <div className="font-small col-2">C = Brands : Monster, Monster Espresso, Innocent</div>
                                        <div className="font-small col-2">D = Seasonal, IN/OUT activities, sampling, BIB, TANK</div>
                                        <div className="font-small col-2">E = Delisted</div>
                                        <div className="font-small col-2">F = Customer dedicated pallets if not launched as permanent SKU</div> */}
                                        {skuExclusionStatuses.map((element) => (
                                            <div className="font-small col-2">{element.id} = {element.title}</div>
                                        ))}
                                    </div>
                                </footer>
                            </div>) : ""
                        }
                        {/* Table(If Data Present) */}
                        {/* No Data Message */}
                        {skuPerformanceList.length === 0 && loading === false ? (<div className="table-data-note"><p>No data found.</p>
                            <p></p>
                        </div>) : ""}
                        </>
                        :
                        <>          
                        {(skuBestPerformingList.length > 0 && !bestPerformingTabLoading) ?(
                            <div className="sku-table-container">
                                <TableSKUBestPerforming 
                                    handleBanPopupModal={handleBanPopupModal}
                                    handleSorting={handleBestPerformingSorting}
                                    updateChangedSKUBestPerforming={updateChangedSKUBestPerforming}
                                    setBestPerformingValues={setBestPerformingValues}
                                    skuPerformanceList={skuBestPerformingList}
                                    changedSKUBestPerformingObjects={changedSKUBestPerformingObjects}
                                />
                            </div>) : ""
                        }
                        {/* Table(If Data Present) */}
                        {/* No Data Message */}
                        {skuBestPerformingList.length === 0 && bestPerformingTabLoading === false ? (<div className="table-data-note"><p>No data found.</p>
                            <p></p>
                        </div>) : ""
                    }
                        </>
                    }
                        {/* No Dta Message */}
                        {/* Ban Popup Modal */}
                        {isBanPopupModalOpen ?
                            <SKUBanPopupModal isBanPopupModalOpen={isBanPopupModalOpen} handleBanPopupModal={handleBanPopupModal}
                                ban_number={selectedBan} business_unit={selectedCountry} current_quarter={selectedTable ==="sku_exclusion_table" ? currentQuarter : currentBestPerformingQuarter}
                            />
                            : ""}
                        {/* Ban Popup Modal */}
                        {/* Message Dialogue Box */}
                        {openCommentDialogueBox ? <SKUDialogueBox openDialogueBox={openCommentDialogueBox}
                            handleCommentDialogueBox={handleCommentDialogueBox}
                            messageType="Info"
                            message={isTypeCommentApplicable ? 
                           alertMessage :
                           "Do you want to Submit the changes made"}
                            handleOnSave={handleSubmitAPICall}
                            isTypeCommentApplicable={isTypeCommentApplicable} /> : ""}
                        {/* Message Dialogue Box */}
                        {/* Loader */}
                        <Toaster />
                        {/* Loader */}
                    </div>
           </Suspense>
    )
}
 
export default ExclusionList